var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"container",staticClass:"frc-captcha",attrs:{"data-sitekey":_vm.siteKey,"data-lang":"fr"}}),_vm._t("default",null,{"captchaToken":_vm.captchaToken,"isCaptchaValid":_vm.widget && _vm.widget.valid})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }